<h2>Review your report</h2>
<p>Ensure it's accurate before you submit it.</p>

<!-- <div class="bigDisplayOnly" *ngIf="!isMobile.any()"> -->
<ng-container *ngIf="!isMobile.any()">
    <div [class.desktopDisplayOnly]="!isMobile.any()">
        <div class="problemSubmissionEntry underlineBorder">
            <h3 class="entryTitle">Problem type</h3>
            <div class="entryInput">
                <span>{{selectedProblemMenuItem!.MenuOne}}</span>
                <span *ngIf="selectedProblemMenuItem!.MenuTwo.length !== 0"> &gt;
                    {{selectedProblemMenuItem!.MenuTwo}}</span>
                <span *ngIf="selectedProblemMenuItem!.MenuThree.length !== 0"> &gt;
                    {{selectedProblemMenuItem!.MenuThree}}</span>
            </div>
            <div class="entryEdit">
                <span (click)="goToStep(1)" tabindex="0" (keypress)="handleKeypress($event)"
                    (mousedown)="handleMouseDown($event)">Edit</span>
            </div>
        </div>

        <div class="problemSubmissionEntry underlineBorder">
            <h3 class="entryTitle">Location</h3>
            <div class="entryInput">
                <div id="mapLocation" class="entryLocation">{{problemLocation}}</div>
                <div id="map" class="map entryMap"></div>
            </div>
            <div class="entryEdit">
                <span (click)="goToStep(2)" tabindex="0" (keypress)="handleKeypress($event)"
                    (mousedown)="handleMouseDown($event)">Edit</span>
            </div>
        </div>

        <div class="problemSubmissionEntry underlineBorder">
            <h3 class="entryTitle">Further details</h3>
            <div class="entryInput">
                <div [innerHTML]="generateNewProblemDesc()"></div>

                <ng-container *ngIf="problemPhotos.length > 0">
                    <div class="submissionPhotos">

                        <ng-container *ngFor="let photoFile of problemPhotos; let i = index">
                            <div class="photoItem addedPhoto">
                                <img src="{{photoFile.dataURL}}">
                            </div>
                        </ng-container>
                    </div>
                </ng-container>
            </div>
            <div class="entryEdit">
                <span (click)="goToStep(3)" tabindex="0" (keypress)="handleKeypress($event)"
                    (mousedown)="handleMouseDown($event)">Edit</span>
            </div>
        </div>

        <div class="problemSubmissionEntry">
            <h3 class="entryTitle">Contact information</h3>

            <div class="entryInput" *ngIf="!contactEntryPopulated()">No contact information provided</div>
            <div class="entryInput" *ngIf="contactEntryPopulated()">
                <div>{{contactInfoLocal!.firstName}} {{contactInfoLocal!.lastName}}</div>
                <div *ngIf="contactInfoLocal!.address">{{contactInfoLocal!.address}}</div>
                <div>{{contactInfoLocal!.email}}</div>

                <ng-container *ngFor="let phone of contactInfoLocal!.phone">
                    <div>{{convertToPhoneType(phone.phoneType)}}: {{getPhoneFormatting(phone.phoneNumber)}}</div>
                    <!-- <div>
                        <span>{{convertToPhoneType(phone.phoneType)}}: {{getPhoneFormatting(phone.phoneNumber)}}</span>
                    </div> -->
                </ng-container>

                <div *ngIf="contactInfoLocal.notificationsRequested">You have requested to be notified about the status
                    of this problem submission.</div>
                <div *ngIf="!contactInfoLocal.notificationsRequested">You have declined to receive notifications about
                    the status of the problem you submitted.</div>
                <!-- <div>Notifications: <strong>{{getNotificationStatus()}}</strong></div> -->
            </div>
            <div class="entryEdit">
                <span (click)="goToStep(4)" tabindex="0" (keypress)="handleKeypress($event)"
                    (mousedown)="handleMouseDown($event)">Edit</span>
            </div>
        </div>
    </div>
</ng-container>

<ng-container *ngIf="isMobile.any()">
    <div [class.mobileDisplayOnly]="isMobile.any()">
        <div class="problemSubmissionEntry underlineBorder">
            <div class="entryEdit">
                <span (click)="goToStep(1)" tabindex="0"
                (keypress)="handleKeypress($event)" (mousedown)="handleMouseDown($event)">Edit</span>
            </div>
            <h3 class="entryTitle">Problem type</h3>
            <div class="entryInput">
                <span>{{selectedProblemMenuItem!.MenuOne}}</span>
                <span *ngIf="selectedProblemMenuItem!.MenuTwo.length !== 0"> &gt;
                    {{selectedProblemMenuItem!.MenuTwo}}</span>
                <span *ngIf="selectedProblemMenuItem!.MenuThree.length !== 0"> &gt;
                    {{selectedProblemMenuItem!.MenuThree}}</span>
            </div>
        </div>

        <div class="problemSubmissionEntry underlineBorder">
            <div class="entryEdit">
                <span (click)="goToStep(2)" tabindex="0"
                (keypress)="handleKeypress($event)" (mousedown)="handleMouseDown($event)">Edit</span>
            </div>
            <h3 class="entryTitle">Location</h3>
            <div class="entryInput">
                <div id="mapLocation" class="entryLocation">{{problemLocation}}</div>
                <div id="map" class="map entryMap"></div>
            </div>
        </div>

        <div class="problemSubmissionEntry underlineBorder">
            <div class="entryEdit">
                <span (click)="goToStep(3)" tabindex="0"
                (keypress)="handleKeypress($event)" (mousedown)="handleMouseDown($event)">Edit</span>
            </div>
            <h3 class="entryTitle">Further details</h3>
            <div class="entryInput">
                <div [innerHTML]="generateNewProblemDesc()"></div>

                <ng-container *ngIf="problemPhotos.length > 0">
                    <div class="submissionPhotos">

                        <ng-container *ngFor="let photoFile of problemPhotos; let i = index">
                            <div class="photoItem addedPhoto">
                                <img src="{{photoFile.dataURL}}">
                            </div>
                        </ng-container>
                    </div>
                </ng-container>
            </div>
        </div>

        <div class="problemSubmissionEntry">
            <div class="entryEdit">
                <span (click)="goToStep(4)" tabindex="0"
                (keypress)="handleKeypress($event)" (mousedown)="handleMouseDown($event)">Edit</span>
            </div>
            <h3 class="entryTitle">Contact information</h3>

            <ng-container *ngIf="!contactEntryPopulated()">
                <div class="entryInput">No contact information provided</div>
            </ng-container>
            <ng-container *ngIf="contactEntryPopulated()">
                <div class="entryInput">
                    <div *ngIf="contactInfoLocal!.firstName || contactInfoLocal!.lastName">
                        {{contactInfoLocal!.firstName}} {{contactInfoLocal!.lastName}}</div>
                    <div *ngIf="contactInfoLocal!.address">{{contactInfoLocal!.address}}</div>
                    <div *ngIf="contactInfoLocal!.email">{{contactInfoLocal!.email}}</div>
                    <div *ngFor="let phone of contactInfoLocal!.phone">
                        <span>{{convertToPhoneType(phone.phoneType)}}: {{getPhoneFormatting(phone.phoneNumber)}}</span>
                    </div>

                    <div *ngIf="contactInfoLocal.notificationsRequested">You have requested to be notified about the
                        status of this problem submission.</div>
                    <div *ngIf="!contactInfoLocal.notificationsRequested">You have declined to receive notifications
                        about the status of the problem you submitted.</div>
                    <!-- <div>Notifications: <strong>{{getNotificationStatus()}}</strong></div> -->
                </div>
            </ng-container>
        </div>
    </div>
</ng-container>